import { Component, OnInit, Input, ElementRef, ViewChildren, QueryList } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { Swiper } from "swiper";

@Component({
    selector: "app-steps",
    templateUrl: "./steps.component.html",
    styleUrls: ["./steps.component.scss"],
})
export class StepsComponent implements OnInit {
    @Input() rendering: ComponentRendering;
    @ViewChildren('StepSwiper') swiperSlider!: QueryList<ElementRef>;
    step: any;
    swiper: Array<Swiper> = [];
    constructor() {}

    ngOnInit() {

    }

    ngAfterViewInit() {
        if(this.swiperSlider){
            this.swiperSlider?.forEach((element : any) => {
                this.swiper.push(new Swiper(element?.nativeElement, {
                    slidesPerView: 1.5,
                    freeMode: true,
                    centeredSlides: false,
                    spaceBetween: 16,
                    grabCursor: true,
                    breakpoints: {
                        1280: {
                            slidesPerView: "auto",
                            enabled: false,
                        },
                    },
                    })
                )
            })
        }
    }
}
